export default __webpack_public_path__ + "static/media/dinnerKeto.6716cc03.svg";